!(function (o, p, s, e, c) {
  var i,
    a,
    h,
    u = [],
    d = [];
  function t() {
    var t = "You must provide a supported major version.";
    try {
      if (!c) throw new Error(t);
      var e,
        n = "https://cdn.smooch.io/",
        r = "smooch";
      if (
        (e =
          "string" == typeof this.response
            ? JSON.parse(this.response)
            : this.response).url
      ) {
        var o = p.getElementsByTagName("script")[0],
          s = p.createElement("script");
        s.async = !0;
        var i = c.match(/([0-9]+).?([0-9]+)?.?([0-9]+)?/),
          a = i && i[1];
        if (i && i[3]) s.src = n + r + "." + c + ".min.js";
        else {
          if (!(4 <= a && e["v" + a])) throw new Error(t);
          s.src = e["v" + a];
        }
        o.parentNode.insertBefore(s, o);
      }
    } catch (e) {
      e.message === t && console.error(e);
    }
  }
  (o[s] = {
    init: function () {
      i = arguments;
      var t = {
        then: function (e) {
          return d.push({ type: "t", next: e }), t;
        },
        catch: function (e) {
          return d.push({ type: "c", next: e }), t;
        },
      };
      return t;
    },
    on: function () {
      u.push(arguments);
    },
    render: function () {
      a = arguments;
    },
    destroy: function () {
      h = arguments;
    },
  }),
    (o.__onWebMessengerHostReady__ = function (e) {
      if ((delete o.__onWebMessengerHostReady__, (o[s] = e), i))
        for (var t = e.init.apply(e, i), n = 0; n < d.length; n++) {
          var r = d[n];
          t = "t" === r.type ? t.then(r.next) : t.catch(r.next);
        }
      a && e.render.apply(e, a), h && e.destroy.apply(e, h);
      for (n = 0; n < u.length; n++) e.on.apply(e, u[n]);
    });
  var n = new XMLHttpRequest();
  n.addEventListener("load", t),
    n.open("GET", "https://" + e + ".webloader.smooch.io/", !0),
    (n.responseType = "json"),
    n.send();
})(window, document, "Smooch", "623496506abaf700f4b68aa4", "5");

function adjustElements(counter) {
  try {
    // adjust back button
    /*if (document.getElementById("icon/arrow-left")) {
              document.getElementById("icon/arrow-left").style.display = "none";
          } else if (document.getElementById("web-messenger-container") && document.getElementById("web-messenger-container").contentWindow.document.getElementById("icon/arrow-left")) {
             document.getElementById("web-messenger-container").contentWindow.document.getElementById("icon/arrow-left").style.display = "none";
          }*/

    // adjust See More
    if (document.getElementById("settings-handle")) {
      document.getElementById("settings-handle").style.display = "none";
    } else if (
      document.getElementById("web-messenger-container") &&
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementById("settings-handle")
    ) {
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementById(
          "settings-handle"
        ).style.display = "none";
    }

    // adjust logo settings
    if (
      document.getElementsByClassName("logo") &&
      document.getElementsByClassName("logo").length > 0
    ) {
      document.getElementsByClassName("logo")[0].style.display = "none";
    } else if (
      document.getElementById("web-messenger-container") &&
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName("logo").length > 0
    ) {
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName(
          "logo"
        )[0].style.display = "none";
    }

    // adjust New Conversation button
    if (
      document.getElementsByClassName("conversation-group-footer") &&
      document.getElementsByClassName("conversation-group-footer").length > 0
    ) {
      document.getElementsByClassName(
        "conversation-group-footer"
      )[0].style.display = "none";
    } else if (
      document.getElementById("web-messenger-container") &&
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName(
          "conversation-group-footer"
        ).length > 0
    ) {
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName(
          "conversation-group-footer"
        )[0].style.display = "none";
    }

    // adjust sync
    if (
      document.getElementsByClassName("intro-pane") &&
      document.getElementsByClassName("intro-pane").length > 0
    ) {
      document.getElementsByClassName("intro-pane")[0].style.display = "none";
    } else if (
      document.getElementById("web-messenger-container") &&
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName("intro-pane").length > 0
    ) {
      document
        .getElementById("web-messenger-container")
        .contentWindow.document.getElementsByClassName(
          "intro-pane"
        )[0].style.display = "none";
    }
  } catch (ex) {
    console.error("adjustElements", ex.message);
  }
  setTimeout(adjustElements, 1000, counter - 1);
}

function addChatbox() {
  Smooch.init({
    integrationId: "65b2b27e1a97b5a789a59d4c",
    customText: {
      actionPaymentCompleted: "Pagamento concluído",
      actionPaymentError:
        "Ocorreu um erro ao processar o cartão. <br> Por favor, tente novamente ou use um cartão diferente.",
      actionPostbackError:
        "Ocorreu um erro ao processar sua ação. Por favor, tente novamente.",
      clickToRetry: "Mensagem não entregue. Clique para tentar novamente.",
      clickToRetryForm:
        "Formulário não enviado. Clique em qualquer lugar do formulário para tentar novamente.",
      connectNotificationText:
        "Sincronize sua conversa e continue nos enviando mensagens através de seu aplicativo favorito.",
      connectNotificationSingleText:
        "Seja notificado quando receber uma resposta.",
      conversationListHeaderText: "Minhas conversas",
      conversationListPreviewAnonymousText: "Alguém",
      conversationListPreviewCarouselText: "{user} enviou uma mensagem",
      conversationListPreviewFileText: "{user} enviou um arquivo",
      conversationListPreviewFormText: "{user} enviou um formulário",
      conversationListPreviewFormResponseText: "{user} preencheu um formulário",
      conversationListPreviewImageText: "{user} enviou uma imagem",
      conversationListPreviewLocationRequestText:
        "{user} enviou uma solicitação de localização",
      conversationListPreviewUserText: "Você",
      conversationListRelativeTimeJustNow: "Agora mesmo",
      conversationListRelativeTimeMinute: "1 minuto atrás",
      conversationListRelativeTimeMinutes: "{value} minutos atrás",
      conversationListRelativeTimeHour: "1 hora atrás",
      conversationListRelativeTimeHours: "{value} horas atrás",
      conversationListRelativeTimeYesterday: "Ontem",
      conversationListTimestampFormat: "MM/DD/AA",
      conversationTimestampHeaderFormat: "D de MMMM de AAAA, h:mm A",
      couldNotConnect: "Offline. Você não receberá mensagens.",
      couldNotConnectRetry: "Reconectando...",
      couldNotConnectRetrySuccess: "Você está online novamente!",
      couldNotLoadConversations: "Não foi possível carregar as conversas.",
      emailChangeAddress: "Alterar meu e-mail",
      emailDescription:
        "Para ser notificado por e-mail quando receber uma resposta, digite seu endereço de e-mail.",
      emailFieldLabel: "E-mail",
      emailFieldPlaceholder: "Seu endereço de e-mail",
      emailFormButton: "Enviar",
      emailLinkingErrorMessage:
        "Por favor, insira um endereço de e-mail válido.",
      fetchHistory: "Carregar mais",
      fetchingHistory: "Recuperando histórico...",
      fileTooLargeError: "Limite de tamanho de arquivo excedido ({size})",
      fileTypeError: "Tipo de arquivo não suportado.",
      formErrorEntryRequired: "Este campo é obrigatório",
      formErrorInvalidEmail: "E-mail inválido",
      formErrorNoLongerThan: "Deve conter no máximo ({characters}) caracteres",
      formErrorNoShorterThan:
        "Deve conter pelo menos ({characters}) caracteres",
      formErrorUnknown: "Isso não parece estar correto",
      formFieldSelectPlaceholderFallback: "Escolha uma opção...",
      frontendEmailChannelDescription:
        "Para falar conosco por e-mail, basta enviar uma mensagem para o nosso endereço de e-mail e responderemos em breve:",
      headerText: "Como podemos ajudar?",
      imageClickToReload: "Clique para recarregar a imagem.",
      imageClickToView: "Clique para visualizar a imagem {size}.",
      imagePreviewNotAvailable: "Visualização indisponível.",
      inputPlaceholder: "Digite uma mensagem...",
      inputPlaceholderBlocked: "Preencha o formulário acima...",
      introAppText:
        "Envie-nos uma mensagem abaixo ou pelo seu aplicativo favorito.",
      lineChannelDescription:
        "Para falar conosco usando o LINE, escaneie este código QR usando o aplicativo LINE e nos envie uma mensagem.",
      linkError:
        "Ocorreu um erro ao tentar gerar um link para este canal. Por favor, tente novamente.",
      linkChannelPageHeader: "Sincronize sua conversa",
      locationNotSupported:
        "Seu navegador não suporta serviços de localização ou eles estão desativados. Por favor, digite sua localização.",
      locationSecurityRestriction:
        "Este site não pode acessar sua localização. Por favor, digite sua localização.",
      locationSendingFailed: "Não foi possível enviar a localização",
      locationServicesDenied:
        "Este site não pode acessar sua localização. Permita o acesso em suas configurações ou digite sua localização.",
      messageIndicatorTitlePlural: "({count}) Novas mensagens",
      messageIndicatorTitleSingular: "({count}) Nova mensagem",
      messageRelativeTimeDay: "{value}d atrás",
      messageRelativeTimeHour: "{value}h atrás",
      messageRelativeTimeJustNow: "Agora mesmo",
      messageRelativeTimeMinute: "{value}m atrás",
      messageTimestampFormat: "h:mm A",
      messageDelivered: "Entregue",
      messageSeen: "Visualizada",
      messageSending: "Enviando...",
      messengerChannelDescription:
        "Conecte sua conta do Facebook Messenger para ser notificado quando receber uma resposta e continuar a conversa no Facebook Messenger.",
      newConversationButtonText: "Nova Conversa",
      notificationSettingsChannelsDescription:
        "Sincronize esta conversa conectando-se ao seu aplicativo de mensagens favorito para continuar a conversa do seu jeito.",
      notificationSettingsChannelsTitle: "Outros Canais",
      notificationSettingsConnected: "Conectado",
      notificationSettingsConnectedAs: "Conectado como {username}",
      prechatCaptureGreetingText:
        "Olá 👋\nPara começar, gostaríamos de saber um pouco mais sobre você:",
      prechatCaptureNameLabel: "Seu nome",
      prechatCaptureNamePlaceholder: "Digite seu nome...",
      prechatCaptureEmailLabel: "E-mail",
      prechatCaptureEmailPlaceholder: "nome@empresa.com",
      prechatCaptureConfirmationText: "Obrigado por isso! Como podemos ajudar?",
      prechatCaptureMailgunLinkingConfirmation:
        "Você será notificado aqui e por e-mail em {email} assim que respondermos.",
      sendButtonText: "Enviar",
      settingsHeaderText: "Configurações",
      shareLocation: "Localização",
      smsBadRequestError:
        "Não foi possível comunicar com este número. Tente novamente ou use um diferente.",
      smsCancel: "Cancelar",
      smsChangeNumber: "Alterar meu número",
      smsChannelDescription:
        "Conecte seu número de SMS para ser notificado quando receber uma resposta e continuar a conversa via SMS.",
      smsChannelPendingDescription:
        "Verifique suas mensagens em {number} para confirmar seu número de telefone.",
      smsContinue: "Enviar",
      smsInvalidNumberError: "Por favor, insira um número de telefone válido.",
      smsLinkCancelled: "A vinculação a {appUserNumber} foi cancelada.",
      smsLinkPending: "Pendente",
      smsPingChannelError:
        "Ocorreu um erro ao enviar uma mensagem para o seu número.",
      smsSendText: "Envie uma mensagem de texto para mim",
      smsStartTexting: "Começar a enviar mensagens",
      smsTooManyRequestsError:
        "Recentemente foi solicitada uma conexão para esse número. Por favor, tente novamente em {minutes} minutos.",
      smsTooManyRequestsOneMinuteError:
        "Recentemente foi solicitada uma conexão para esse número. Por favor, tente novamente em 1 minuto.",
      smsUnhandledError: "Algo deu errado. Por favor, tente novamente.",
      syncConversation: "Sincronizar conversa",
      tapToRetry: "Mensagem não entregue. Toque para tentar novamente.",
      tapToRetryForm:
        "Formulário não enviado. Toque em qualquer lugar do formulário para tentar novamente.",
      telegramChannelDescription:
        "Conecte sua conta do Telegram para ser notificado quando receber uma resposta e continuar a conversa no Telegram.",
      unsupportedMessageType: "Tipo de mensagem não suportado.",
      unsupportedActionType: "Tipo de ação não suportado.",
      uploadDocument: "Arquivo",
      uploadInvalidError: "Arquivo inválido",
      uploadPhoto: "Imagem",
      uploadVirusError:
        "Um vírus foi detectado em seu arquivo e ele foi rejeitado",
      viberChannelDescription:
        "Conecte sua conta do Viber para ser notificado quando receber uma resposta e continuar a conversa no Viber. Para começar, escaneie o código QR usando o aplicativo Viber.",
      viberChannelDescriptionMobile:
        "Conecte sua conta do Viber para ser notificado quando receber uma resposta e continuar a conversa no Viber. Para começar, instale o aplicativo Viber e toque em Conectar.",
      viberQRCodeError:
        "Ocorreu um erro ao buscar o código QR do Viber. Por favor, tente novamente.",
      wechatChannelDescription:
        "Conecte sua conta do WeChat para ser notificado quando receber uma resposta e continuar a conversa no WeChat. Para começar, escaneie este código QR usando o aplicativo WeChat.",
      wechatChannelDescriptionMobile:
        "Conecte sua conta do WeChat para ser notificado quando receber uma resposta e continuar a conversa no WeChat. Para começar, salve esta imagem do código QR e faça o upload no <a href='weixin://dl/scan'>scanner de código QR</a>.",
      wechatQRCodeError:
        "Ocorreu um erro ao buscar o código QR do WeChat. Por favor, tente novamente.",
      whatsappChannelDescriptionDesktop:
        "Sincronize sua conta no WhatsApp escaneando o código QR ou clicando no link abaixo.\nEm seguida, envie a mensagem pré-preenchida para validar a solicitação de sincronização. (Seu código: {{code}}).",
      whatsappChannelDescriptionMobile:
        "Sincronize sua conta no WhatsApp clicando no link abaixo.\nEm seguida, envie a mensagem pré-preenchida para validar a solicitação de sincronização. (Seu código: {{code}}).",
      whatsappLinkingError:
        "Ocorreu um erro ao buscar as informações de vinculação do WhatsApp. Por favor, tente novamente.",
    },
  });
  adjustElements(500);
}

function removeChatbox() {
  Smooch.destroy();
}

export { addChatbox, removeChatbox };
